// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { GenericTableComponent } from "@lg/ng-shared";
import { MatTableModule } from "@angular/material/table";

interface Properties {
    request: This.CustomerRequest;
    receivedOfferCount: number;
    highlightOfferId: This.VendorOffer.Id | undefined;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-VendorOffersInclude',
    templateUrl: './VendorOffersInclude.html',
    styleUrls: ['./VendorOffersInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        MatCardModule,
        MatButtonModule,
        GenericTableComponent,
        MatTableModule
    ],
})
export class VendorOffersInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.VendorOffersInclude';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    @Output()
    submit = new EventEmitter<This.CustomerRequest>();
    output = {
        submit: async (data: This.CustomerRequest, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('submit', data)
            this.submit.emit(data)
            if (this.dialogData?.closeOnOutput === 'submit') { this.dialogRef?.close(data) }
            return result
        },
    };
    _DataTableBlock_columns_97 = (screen: Properties) => ['quantity', 'unitPrice', 'deliveryTime'];
    $validators: Record<number, ValidationRules> = {

    };
    input_request = input(undefined, { alias: 'request' });
    var_request = proxySignal<This.CustomerRequest>(undefined as any);
    var_receivedOfferCount = proxySignal<number>(undefined as any);
    input_highlightOfferId = input(undefined, { alias: 'highlightOfferId' });
    var_highlightOfferId = proxySignal<This.VendorOffer.Id | undefined>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get request() { return component.var_request() },
                set request(value: This.CustomerRequest) { component.var_request.set(value) },
                get receivedOfferCount() { return component.var_receivedOfferCount() },
                set receivedOfferCount(value: number) { component.var_receivedOfferCount.set(value) },
                get highlightOfferId() { return component.var_highlightOfferId() },
                set highlightOfferId(value: This.VendorOffer.Id | undefined) { component.var_highlightOfferId.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            request: this.screen.request,
            highlightOfferId: this.screen.highlightOfferId
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_request = this.dialogData?.data?.request ?? this.input_request() ?? (undefined)
            if (new_request !== undefined) this.screen.request = new_request

            if (!isVariablesInitialized) this.screen.receivedOfferCount = (undefined)

            const new_highlightOfferId = this.dialogData?.data?.highlightOfferId ?? this.input_highlightOfferId() ?? (undefined)
            if (new_highlightOfferId !== undefined) this.screen.highlightOfferId = new_highlightOfferId

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_ButtonBlock_124_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (confirm('Are you sure you want to continue with only the received offers?')) {
                        const evaluationProcessId = await This.TechnicalDrawingParser.startEvaluationWithReceivedOffers(screen.request.id)
                        if (evaluationProcessId) {
                            screen.request.evaluationProcessId = evaluationProcessId
                        }
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_123_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (confirm('Are you sure you want to close the whole customer request?')) {
                        await This.Db.updateById(This.CustomerRequest, screen.request.id, {
                            status$id: This.CustomerRequestStatus.Closed.id,
                        })
                        screen.request.status.setClosed()
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_97(component: any, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, offer: This.VendorOffer, offerIndex: number, item: This.VendorOfferItem, itemIndex: number } = $scope ?? {}
                return (item.quantities)
            }, { equal: () => false })
        )

    }

    _DataTableBlock_additionalFindOptions_97($scope: any): any {
        let { app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, offer: This.VendorOffer, offerIndex: number, item: This.VendorOfferItem, itemIndex: number } = $scope ?? {}

        return ({})
    }

    _DataTableColumnBlock_cellText_99($scope: any): any {
        let { app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex, quantity, quantityIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, offer: This.VendorOffer, offerIndex: number, item: This.VendorOfferItem, itemIndex: number, quantity: This.VendorOfferItemQuantity, quantityIndex: number } = $scope ?? {}

        return (quantity.quantity)
    }

    _DataTableColumnBlock_cellText_113($scope: any): any {
        let { app, screen, $pathSegments, $disabled, offer, offerIndex, item, itemIndex, quantity, quantityIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, offer: This.VendorOffer, offerIndex: number, item: This.VendorOfferItem, itemIndex: number, quantity: This.VendorOfferItemQuantity, quantityIndex: number } = $scope ?? {}

        return (quantity.deliveryTime)
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.receivedOfferCount = screen.request.vendorOffers.filter(o => o.status.isReceived).length
        }
    }
}
